import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../../lib';
import API from "../../api";

class CheckIfUserAuth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            trigger: false,
        };
        this.triggetNext = this.triggetNext.bind(this);
    }
    componentDidMount() {
        const {trueStep,falseStep,updateStore}  = this.props;
        API.isPatientVerify().then((result) => {
            // this.setState({loading: false});
            if (result.validateLogin) {
                updateStore('patient', {
                    id: result.patient_id,
                    name: result.name,
                    national_id: result.national_id,
                    email: result.email,
                    verified: true,
                });
                this.triggetNext(true, trueStep);
            } else {
                this.triggetNext(false, falseStep);
            }

        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }

    triggetNext(value, trigger) {
        this.setState({trigger: true});
        this.props.triggerNextStep({value: value, trigger: trigger})
    }
    render() {
        const {loading} = this.state;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (

                    ''
                )}
            </div>
        );
    }
}

CheckIfUserAuth.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

CheckIfUserAuth.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default CheckIfUserAuth;
